import { SectionHeading } from "@/components/Section";

const content = {
  terms: {
    title: "Terms of Service",
    body: [
      ["Overview", "By using ADNEXA DIGITAL and purchasing our services, you agree to these Terms of Service. Our services are provided for legitimate business marketing purposes and in accordance with the policies of the advertising platforms we work with."],
      ["Services", "We provide performance marketing, paid advertising, SEO and related digital services. Deliverables, timelines and pricing are described on each service and package. We do not guarantee specific results such as sales volumes or search ranking positions."],
      ["Payments", "Services are paid in USDT via supported networks. Payment must be confirmed on-chain before service delivery begins. Advertising spend on third-party platforms is billed separately."],
      ["Client Responsibilities", "You are responsible for providing accurate information, timely access to accounts and assets, and for compliance with the terms of any third-party platform used in your campaigns."],
      ["Limitation of Liability", "ADNEXA DIGITAL is not liable for outcomes outside our control, including third-party platform decisions, policy changes or account actions."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      ["Information We Collect", "We collect account information you provide (name, email, phone, country) and information related to your orders and payments to deliver our services."],
      ["How We Use Information", "We use your information to process orders, deliver services, communicate updates and improve our platform. We never sell your personal information."],
      ["Payment Data", "We store transaction references for verification. We never store private keys or wallet credentials."],
      ["Security", "We apply reasonable technical and organizational measures including encryption of passwords and protected access controls."],
      ["Your Rights", "You may request access to or deletion of your account data by contacting our support team."],
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      ["General", "Because our services involve strategic and creative work delivered over time, refunds are considered on a case-by-case basis."],
      ["Before Work Begins", "If no work has started on your order, you may request a refund of amounts paid, subject to network transaction considerations."],
      ["After Work Begins", "Once campaign setup or service delivery has begun, fees for completed work are non-refundable. Remaining unused amounts may be eligible for partial refund."],
      ["How to Request", "Contact our support team with your Order ID. We aim to respond to all refund requests promptly and transparently."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = content[kind] || content.terms;
  return (
    <div className="section-lux">
      <div className="container-lux max-w-3xl">
        <SectionHeading label="Legal" title={c.title} />
        <div className="mt-10 space-y-8">
          {c.body.map(([h, p], i) => (
            <div key={i}>
              <h3 className="text-lg font-semibold text-amber-400 mb-2">{h}</h3>
              <p className="text-slate-400 leading-relaxed">{p}</p>
            </div>
          ))}
          <p className="text-xs text-slate-600 pt-4 border-t border-white/5">Last updated: 2026. This document is provided for general information and can be edited from the Admin Panel content system.</p>
        </div>
      </div>
    </div>
  );
}
